module.exports = __webpack_public_path__ + "img/17.c5128560.png";